// import React, { useState } from 'react';
// import { Box, TextField, Autocomplete, IconButton } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';

// const SearchBar = ({
//     studentOptions = [], // student name list
//     apartmentOptions = [], // apartment list
//     onSearch,
//     onApartmentSelect,
//     ...props
// }) => {
//     const [keyword, setKeyword] = useState('');
//     const [selectedApartment, setSelectedApartment] = useState(null);
//     const [openNameDropdown, setOpenNameDropdown] = useState(false);

//     const handleKeyPress = (e) => {
//         if (e.key === 'Enter') {
//             onSearch?.(keyword.trim());
//         }
//     };

//     const handleSearchClick = () => {
//         onSearch?.(keyword.trim());
//     };

//     // Only show student name matches if keyword length >= 3
//     const filteredStudentOptions =
//         keyword.length >= 3
//             ? studentOptions.filter(opt =>
//                 opt.label?.toLowerCase().includes(keyword.toLowerCase())
//             )
//             : [];

//     return (
//         <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
//             <Box
//                 sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     border: '2px solid #E2002B',
//                     borderRadius: '50px',
//                     overflow: 'hidden',
//                     width: { xs: '100%' },
//                     bgcolor: '#fff'
//                 }}
//             >
//                 {/* Student Name Search - 50% */}
//                 <Box sx={{ flex: 1 }}>

//                     <Autocomplete
//                         freeSolo
//                         options={filteredStudentOptions}
//                         getOptionLabel={(option) => option.label || ''}
//                         inputValue={keyword}
//                         onInputChange={(_, newValue, reason) => {
//                             setKeyword(newValue);
//                             onSearch?.(newValue.trim());
//                             if (reason === 'input') {
//                                 setOpenNameDropdown(newValue.length >= 3);
//                             }
//                         }}
//                         open={openNameDropdown && filteredStudentOptions.length > 0}
//                         onOpen={() => {
//                             if (keyword.length >= 3) setOpenNameDropdown(true);
//                         }}
//                         onClose={() => setOpenNameDropdown(false)}
//                         renderInput={(params) => (
//                             <TextField
//                                 {...params}
//                                 placeholder="Search by student name"
//                                 onKeyDown={handleKeyPress}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': {
//                                         borderRadius: 0,
//                                         backgroundColor: 'transparent',
//                                         '& fieldset': { border: 'none' }
//                                     }
//                                 }}
//                             />
//                         )}
//                     />
//                 </Box>

//                 <Box sx={{ width: '1px', bgcolor: '#ddd', height: 30 }} />

//                 {/* Apartment Search - 50% */}
//                 <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
//                     <Box sx={{ width: '90%' }}>
//                         <Autocomplete
//                             options={apartmentOptions}
//                             getOptionLabel={(option) => option.label || ''}
//                             value={selectedApartment}
//                             onChange={(_, value) => {
//                                 setSelectedApartment(value);
//                                 onApartmentSelect?.(value?.id || null);
//                             }}
//                             renderInput={(params) => (
//                                 <TextField
//                                     {...params}
//                                     placeholder="Apartment"
//                                     variant="outlined"
//                                     sx={{
//                                         flex: 1,
//                                         '& .MuiOutlinedInput-root': {
//                                             borderRadius: 0,
//                                             backgroundColor: 'transparent',
//                                             '& fieldset': { border: 'none' }
//                                         }
//                                     }}
//                                 />
//                             )}
//                         />
//                     </Box>
//                     <IconButton
//                         sx={{
//                             bgcolor: 'red.main',
//                             color: '#fff',
//                             borderRadius: '50%',
//                             m: 0.5,
//                             '&:hover': { bgcolor: 'red.dark' }
//                         }}
//                         onClick={handleSearchClick}
//                     >
//                         <SearchIcon />
//                     </IconButton>
//                 </Box>


//             </Box>
//         </Box>
//     );
// };

// export default SearchBar;



import React, { useState } from 'react';
import { Box, TextField, Autocomplete, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({
    studentOptions = [],
    apartmentOptions = [],
    onSearch,
    onApartmentSelect,
    isHideApartment = false,
    ...props
}) => {
    const [keyword, setKeyword] = useState('');
    const [apartmentKeyword, setApartmentKeyword] = useState('');
    const [selectedApartment, setSelectedApartment] = useState(null);
    const [openNameDropdown, setOpenNameDropdown] = useState(false);
    const [openApartmentDropdown, setOpenApartmentDropdown] = useState(false);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSearch?.(keyword.trim());
        }
    };

    const handleSearchClick = () => {
        onSearch?.(keyword.trim());
    };

    // Filter student names if keyword length >= 3
    const filteredStudentOptions =
        keyword.length >= 3
            ? studentOptions.filter(opt =>
                opt.label?.toLowerCase().includes(keyword.toLowerCase())
            )
            : [];

    // Filter apartments if keyword length >= 3
    const filteredApartmentOptions =
        apartmentKeyword.length >= 3
            ? apartmentOptions.filter(opt =>
                opt.label?.toLowerCase().includes(apartmentKeyword.toLowerCase())
            )
            : [];

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '2px solid #E2002B',
                    borderRadius: '50px',
                    overflow: 'hidden',
                    width: { xs: '100%' },
                    bgcolor: '#fff'
                }}
            >
                {/* Student Name Search - 50% */}
                <Box sx={{ flex: 1 }}>
                    <Autocomplete
                        freeSolo
                        options={filteredStudentOptions}
                        getOptionLabel={(option) => option.label || ''}
                        inputValue={keyword}
                        onInputChange={(_, newValue, reason) => {
                            setKeyword(newValue);
                            onSearch?.(newValue.trim());
                            if (reason === 'input') {
                                setOpenNameDropdown(newValue.length >= 3);
                            }
                        }}
                        // open={openNameDropdown && filteredStudentOptions.length > 0}
                        // onOpen={() => {
                        //     if (keyword.length >= 3) setOpenNameDropdown(true);
                        // }}
                        // onClose={() => setOpenNameDropdown(false)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder={props?.placeholder ?? "Search by student name"}
                                onKeyDown={handleKeyPress}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 0,
                                        paddingLeft: "1rem",
                                        backgroundColor: 'transparent',
                                        '& fieldset': { border: 'none' }
                                    }
                                }}
                            />
                        )}
                    />
                </Box>
                {
                    !isHideApartment && <>
                        <Box sx={{ width: '1px', bgcolor: '#ddd', height: 30 }} />

                        {/* Apartment Search - 50% */}
                        <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
                            <Box sx={{ flex: 1 }}>
                                <Autocomplete
                                    freeSolo
                                    options={filteredApartmentOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    inputValue={apartmentKeyword}
                                    onInputChange={(_, newValue, reason) => {
                                        setApartmentKeyword(newValue);
                                        if (reason === 'input') {
                                            setOpenApartmentDropdown(newValue.length >= 3);
                                        }
                                    }}
                                    value={selectedApartment}
                                    onChange={(_, value) => {
                                        setSelectedApartment(value);
                                        onApartmentSelect?.(value?.id || null);
                                    }}
                                    open={openApartmentDropdown && filteredApartmentOptions.length > 0}
                                    onOpen={() => {
                                        if (apartmentKeyword.length >= 3) setOpenApartmentDropdown(true);
                                    }}
                                    onClose={() => setOpenApartmentDropdown(false)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder={props?.secondPlaceholder ?? "Apartment"}
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: 0,
                                                    backgroundColor: 'transparent',
                                                    '& fieldset': { border: 'none' }
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                            <IconButton
                                sx={{
                                    bgcolor: 'red.main',
                                    color: '#fff',
                                    borderRadius: '50%',
                                    m: 0.5,
                                    '&:hover': { bgcolor: 'red.main' }
                                }}
                                onClick={handleSearchClick}
                            >
                                <SearchIcon />
                            </IconButton>
                        </Box>
                    </>
                }

            </Box>
        </Box>
    );
};

export default SearchBar;

